import React from 'react';
import Button from 'devextreme-react/button';

import CoreUtils from '../../../common/utils/CoreUtils';
import DateTimeUtils from '../../../common/utils/DateTimeUtils';

import DataItemView from '../../../common/view/DataItemView';
import ModifiedFlag from '../../../common/controls/ModifiedFlag';
import ErrorFlag from '../../../common/controls/ErrorFlag';

import MonthEditor from '../../../common/metadata/MonthEditor';
import SelectEditor from '../../../common/metadata/SelectEditor';

export default class ContractRangeView extends DataItemView {
  static displayName = ContractRangeView.name;

  constructor(props) {
    super(props);

    this.onEditorValueListener = this.onEditorValueChanged.bind(this);
    this.bindDataItem(props.contractRange);
  }

  componentDidUpdate() {
    this.bindDataItem(this.props.contractRange);
  }

  render() {
    if (!this.state.isDataBound)
      return (<div />);

    return (
      <tr className={this.getContractRangeViewClassNames(this.state.isDeleted)}>
        <td>
          <MonthEditor
            dropDownOptions={{
              wrapperAttr: {
                class: 'pwx-contract-range-date-dropdown'
              }
            }}
            height="24px"
            name="startDate"
            onValueChanged={this.onEditorValueListener}
            postEditFilter={DateTimeUtils.nudgeDateToFirstDayOfMonth}
            value={this.state.startDate}
            width="135px"
          />
        </td>
        <td>
          <ModifiedFlag isModifiedProperty={this.state.startDate_isModified} />
          <ErrorFlag errorProperty={this.state.startDate_error} />
        </td>
        <td className="pwx-contract-range-gap" />
        <td>
          <MonthEditor
            dropDownOptions={{
              wrapperAttr: {
                class: 'pwx-contract-range-date-dropdown'
              }
            }}
            height="24px"
            name="endDate"
            onValueChanged={this.onEditorValueListener}
            postEditFilter={DateTimeUtils.nudgeDateToLastDayOfMonth}
            value={this.state.endDate}
            width="135px"
          />
        </td>
        <td>
          <ModifiedFlag isModifiedProperty={this.state.endDate_isModified} />
          <ErrorFlag errorProperty={this.state.endDate_error} />
        </td>
        <td className="pwx-contract-range-gap" />
        <td className="pwx-select-box">
          <SelectEditor
            dropDownOptions={{
              wrapperAttr: {
                class: 'pwx-contract-range-role-dropdown'
              }
            }}
            options={this.state.rangeViewerRole_options}
            displayExpr="displayValue"
            height="24px"
            name="rangeViewerRole"
            showClearButton={false}
            value={this.state.rangeViewerRole}
            onValueChanged={this.onEditorValueListener}
            width="155px"
          />
        </td>
        <td>
          <ModifiedFlag isModifiedProperty={this.state.rangeViewerRole_isModified} />
          <ErrorFlag errorProperty={this.state.rangeViewerRole_error} />
        </td>
        <td className="pwx-contract-range-gap" />
        <td className="pwx-select-box">
          <SelectEditor
            dropDownOptions={{
              wrapperAttr: {
                class: 'pwx-contract-range-role-dropdown'
              }
            }}
            options={this.state.rangeEditorRole_options}
            displayExpr="displayValue"
            height="24px"
            name="rangeEditorRole"
            showClearButton={false}
            value={this.state.rangeEditorRole}
            onValueChanged={this.onEditorValueListener}
            width="155px"
          />
        </td>
        <td>
          <ModifiedFlag isModifiedProperty={this.state.rangeEditorRole_isModified} />
          <ErrorFlag errorProperty={this.state.rangeEditorRole_error} />
        </td>
        <td className="pwx-contract-range-gap" />
        <td className="pwx-contract-range-remove">
            <Button type="normal" icon="remove" disabled={this.state.scheduleCount > 0} onClick={this.onRemoveButtonClicked.bind(this)} />
        </td>
      </tr>
    );
  }

  getContractRangeViewClassNames(isDeleted) {
    var classNames = 'pwx-contract-range-view';
    if (isDeleted)
      classNames += ' pwx-item-deleted';

    return classNames;
  }

  onEditorValueChanged(propertyName, value) {
    if (this.dataItem !== null)
      this.dataItem.updateProperty(propertyName, value);
  }

  onRemoveButtonClicked() {
    if (CoreUtils.isDefinedAndNotNull(this.props.onRemoveContractRange))
      this.props.onRemoveContractRange(this.dataItem);
  }
}